export const isNullOrUndefined = value => {
  return value === null || value === undefined || value === ''
}

export const isEmptyObject = value => {
  return isNullOrUndefined(value) || Object.keys(value).length === 0  
}

export const StaticValuePromise = (value)=>{
    const retVal = new Promise((resolve, reject) => {
      resolve(value);
    });
    return retVal;
} 
